import { useModalStore } from '@/shared/lib';
import { PaidInvoiceDetailsModal } from '../ui';
import type { PaidInvoiceDetailsModalProps } from './types';

const usePaidInvoiceDetailsModal = () => {
  const { showDialogComponent } = useModalStore();

  const openPaidInvoiceDetailsModal = ({
    invoice,
    lang,
    onBack,
  }: PaidInvoiceDetailsModalProps) => {
    showDialogComponent({
      component: (
        <PaidInvoiceDetailsModal
          invoice={invoice}
          lang={lang}
          onBack={onBack}
        />
      ),
      className: 'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto border-0 flex',
    });
  };

  return { openPaidInvoiceDetailsModal };
};

export { usePaidInvoiceDetailsModal };
